import {BsLayersHalf} from "react-icons/bs";
import UILinkButton from "./UILinkButton";

/**
 * Reset Graph Button that reloads the page to the root path. Causes a full page reload.
 */
const OverlayLinkButton = () => {
  return (
    <UILinkButton to="/overlay" title="Overlay Data" icon=<BsLayersHalf/> />
  );
};
export default OverlayLinkButton;